var lib_core = require("lib-core");

var AbstractSelectableInteractionModel = function(data, editorModel) {
    var self = this;

    lib_core.AbstractInteractionModel.call(this, data);

    this.editorModel = editorModel;

    this.isBoxSelectable = true;
    this.isGridSelectable = true;

    this.infocus  = this.value("infocus", true);
    this.selected = this.value("interactionSelected", true);
};
lib_core.inherit(AbstractSelectableInteractionModel, lib_core.AbstractInteractionModel);
module.exports = AbstractSelectableInteractionModel;

/**
 * Determine if any part of this shape is in the bounding box supplied
 * @author Ed Pataky
 * @function inBB
 * @param {lib_geometry.BoundingBox} bb - bounding box
 * @param {boolean} selectAnyMode - true means shape does not need to be totally in box, false means it does
 */
AbstractSelectableInteractionModel.prototype.inBB = function (bb, selectAnyMode) {
    if(selectAnyMode) {
        return this.data.segmentedGeometry(this.editorModel.geometryPrecision()).intersects(bb);
    } else {
        return bb.contains(this.data.boundingBox());
    }
};

AbstractSelectableInteractionModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

AbstractSelectableInteractionModel.prototype.setFocus = function (focus) {
    this.infocus(focus);
};

